<div
  class="checkbox-multi-dropdown"
  [class.checkbox-multi-dropdown--input]="appearance === 'input'"
  [class.checkbox-multi-dropdown--no-footer]="!showFooter"
  [class.checkbox-multi-dropdown--disabled]="disabled"
>
  <button
    #triggerBtn
    type="button"
    class="cmd-trigger"
    role="combobox"
    [disabled]="disabled"
    [attr.aria-disabled]="disabled"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="listbox"
    [attr.aria-controls]="listboxId"
    [attr.aria-labelledby]="computedLabelledBy"
    [attr.aria-label]="accessibleName"
    (click)="toggleOpen($event)"
    (keydown)="onTriggerKeydown($event)"
  >
    <span class="cmd-trigger__icon" aria-hidden="true"
      ><ng-content select="[cmdTriggerIcon]"></ng-content
    ></span>
    <span class="cmd-trigger__label" [attr.id]="valueLabelId">{{ triggerLabel }}</span>
    <span class="cmd-trigger__trailing" aria-hidden="true">
      <span *ngIf="loading" class="cmd-trigger__spinner" role="status" aria-label="Loading"></span>
      <span class="cmd-trigger__chevron" [class.cmd-trigger__chevron--open]="isOpen">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.28033 7.38033L10 12.0996L14.7197 7.38033"
            stroke="#15172E"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </span>
  </button>

  <div
    #menuPanel
    class="cmd-menu"
    [class.cmd-menu--open]="isOpen"
    [class.cmd-menu--input]="appearance === 'input'"
    [class.cmd-menu--no-footer]="!showFooter"
    [class.cmd-menu--fixed-overlay]="fixedOverlay"
    [class.cmd-menu--is-positioned]="fixedOverlayReady"
    [attr.hidden]="isOpen ? null : true"
    (click)="$event.stopPropagation()"
  >
    <div
      class="cmd-list"
      role="listbox"
      [attr.id]="listboxId"
      aria-multiselectable="true"
      [attr.aria-labelledby]="ariaLabelledBy || null"
      [attr.aria-label]="accessibleName"
      (keydown)="onListKeydown($event)"
    >
      <div
        class="cmd-item"
        *ngIf="showAllOption"
        [class.cmd-item--selected]="isAllSelected"
        role="option"
        tabindex="0"
        [attr.data-option-id]="allOptionId"
        [attr.aria-selected]="isAllSelected"
      >
        <app-checkbox
          [checked]="isAllSelected"
          [label]="allOptionLabel"
          [size]="checkboxSize"
          (checkedChange)="onToggleAll()"
        ></app-checkbox>
      </div>

      <div class="cmd-empty" *ngIf="!loading && options.length === 0" role="status">
        {{ emptyMessage }}
      </div>

      <div
        class="cmd-item"
        [class.cmd-item--selected]="isDraftSelected(option.id)"
        role="option"
        tabindex="0"
        *ngFor="let option of options; trackBy: trackById"
        [attr.data-option-id]="option.id"
        [attr.aria-selected]="isDraftSelected(option.id)"
      >
        <app-checkbox
          [checked]="isDraftSelected(option.id)"
          [label]="option.name"
          [size]="checkboxSize"
          (checkedChange)="onToggleOne(option.id)"
        ></app-checkbox>
      </div>
    </div>

    @if (showFooter) {
      <div class="cmd-actions">
        <button type="button" class="cmd-actions__clear" (click)="onClear()">Clear</button>
        <div class="cmd-actions__buttons">
          <button type="button" class="cmd-btn cmd-btn--secondary" (click)="onCancel()">
            Cancel
          </button>
          <button type="button" class="cmd-btn cmd-btn--primary" (click)="onApply()">Apply</button>
        </div>
      </div>
    }

    @if (footerAction) {
      <div class="cmd-footer-action">
        <button
          type="button"
          class="cmd-footer-action__btn"
          [disabled]="footerAction.disabled"
          [attr.aria-disabled]="footerAction.disabled || null"
          (click)="onFooterActionClick($event)"
        >
          {{ footerAction.label }}
        </button>
      </div>
    }
  </div>
</div>
